<template>
    <div>
<!--        Login form deactivated by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.loginFormDeactivated', {user:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "LoginFormDeactivated",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
